import { render } from "./PopupBatchEditor.vue?vue&type=template&id=65ead52d&scoped=true"
import script from "./PopupBatchEditor.vue?vue&type=script&lang=js"
export * from "./PopupBatchEditor.vue?vue&type=script&lang=js"

import "./PopupBatchEditor.vue?vue&type=style&index=0&id=65ead52d&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ead52d"]])

export default __exports__